import { combineReducers } from 'redux'

// Actions
export * as revise from './dashboard/revise'
export * as awards from './dashboard/awards'
export * as persons from './dashboard/persons'
export * as activity from './dashboard/activity'
export * as activityLogs from './dashboard/activityLogs'
export * as notifications from './dashboard/notifications'
export * as residentialProject from './dashboard/residentialProject'
export * as adventurousJourney from './dashboard/adventurous-journey'

// Reducers
/* eslint-disable */
import revise from './dashboard/revise'
import awards from './dashboard/awards'
import persons from './dashboard/persons'
import activity from './dashboard/activity'
import activityLogs from './dashboard/activityLogs'
import notifications from './dashboard/notifications'
import adventurousJourney from './dashboard/adventurous-journey'
import residentialProject from './dashboard/residentialProject'
/* eslint-enable */

export default combineReducers({
  revise,
  awards,
  persons,
  activity,
  activityLogs,
  notifications,
  residentialProject,
  adventurousJourney,
})
